export const isValidEmail = (emailValue) => {
  return /^[\w\.\-\+]+@[a-zA-Z0-9\-]+(\.[a-zA-Z0-9\-]{1,})*(\.[a-zA-Z]{2,5}){1,2}$/.test(emailValue) // eslint-disable-line no-useless-escape
}

export default {
  isValidEmail,
};
